import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdmFilterService {
  private readonly sourceCriteria = new BehaviorSubject<AdmFilterCriteria>({
    floorIds: [],
    tagIds: [],
    startDateUTC: null,
    endDateUTC: null,
    buildingId: null
  });

  get filterCriteria$(): Observable<AdmFilterCriteria> {
    return this.sourceCriteria.asObservable();
  }

  get filterCriteriaValue(): AdmFilterCriteria {
    return this.sourceCriteria.getValue();
  }

  set filterCriteria(criteria: AdmFilterCriteria) {
    this.sourceCriteria.next(criteria);
  }

  resetFilterCriteria(): void {
    this.sourceCriteria.next({
      floorIds: [],
      tagIds: [],
      startDateUTC: null,
      endDateUTC: null
    });
  }

  isEmptyFilterCriteria(): boolean {
    const criteria = this.filterCriteriaValue;
    return (
      criteria.floorIds.length === 0 &&
      criteria.tagIds.length === 0 &&
      criteria.startDateUTC === null &&
      criteria.endDateUTC === null
    );
  }
}

export interface AdmFilterCriteria {
  floorIds: number[];
  tagIds: number[];
  startDateUTC: Date | null;
  endDateUTC: Date | null;
  buildingId?: number;
}
